// Predictive navigation — the page starts loading before the user finishes
// clicking. Two tiers:
//   1. Speculation Rules API (Chrome/Edge): the browser itself prefetches on
//      hover intent (eagerness "moderate" ≈ 50ms hover / pointerdown) and
//      PRERENDERS on pointerdown (eagerness "conservative") — by mouseup the
//      next page is already rendered, activation is ~0ms. The browser handles
//      Save-Data, battery, memory pressure and cancellation natively.
//   2. Fallback (Firefox): vanilla hover-intent <link rel="prefetch"> after a
//      65ms dwell + instant prefetch on touchstart. Safari has no reliable
//      prefetch primitive → degrades to normal navigation.
// Prefetch fetches HTML only (no JS execution → no analytics double-fire, no
// Blazor circuit, no side effects). Prerender DOES run page JS, which is why
// it only fires on pointerdown — at that instant the user is committed and the
// same scripts were about to run anyway.
// Opt-out per link: <a data-no-prefetch>. Excluded path subtrees below.
(function () {
    'use strict';
    if (window.__pdPredictiveNav) return;
    window.__pdPredictiveNav = true;

    // Never speculate: side-effectful, personalized, circuit-heavy or
    // non-Blazor endpoints. Matched as exact path OR subtree ("/admin",
    // "/admin/…") — NOT substring, so "/administratif" stays eligible.
    var EXCLUDE = ['/admin', '/api', '/_blazor', '/_framework', '/media',
        '/login', '/Login', '/Register', '/ForgotPassword', '/ResetPassword',
        '/Users', '/account', '/cart', '/checkout', '/panier', '/scan',
        '/bookings', '/forms-admin', '/product-admin', '/reviews-admin',
        '/OrchardCore', '/cbf-collab-hub', '/Error',
        // Personalized pages that MUTATE during a session: a copy prefetched on
        // hover, then invalidated by an add-to-wishlist click, would render
        // stale on navigation.
        '/wishlist', '/favoris',
        // French storefront slugs for the same personalized/app-like pages
        // (Babylone uses /compte; sites can opt out any link via data-no-prefetch)
        '/compte', '/mon-compte', '/commande', '/paiement'];

    var supportsRules = typeof HTMLScriptElement !== 'undefined'
        && HTMLScriptElement.supports
        && HTMLScriptElement.supports('speculationrules');

    if (supportsRules) {
        var notMatches = [];
        for (var i = 0; i < EXCLUDE.length; i++) {
            notMatches.push(EXCLUDE[i]);          // exact
            notMatches.push(EXCLUDE[i] + '/*');   // subtree
        }
        var where = {
            and: [
                { href_matches: '/*' },
                { not: { href_matches: notMatches } },
                { not: { selector_matches: '[data-no-prefetch], [download], [target="_blank"]' } }
            ]
        };
        var s = document.createElement('script');
        s.type = 'speculationrules';
        s.textContent = JSON.stringify({
            prefetch: [{ where: where, eagerness: 'moderate' }],
            prerender: [{ where: where, eagerness: 'conservative' }]
        });
        document.head.appendChild(s);
        return;
    }

    // ── Fallback: hover-intent <link rel="prefetch"> ──
    var linkOk = false;
    try {
        var probe = document.createElement('link');
        linkOk = !!(probe.relList && probe.relList.supports && probe.relList.supports('prefetch'));
    } catch (e) { }
    if (!linkOk) return;

    var conn = navigator.connection;
    if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

    var done = {}, doneCount = 0, MAX = 40, timer = null, pendingA = null;

    function eligible(a) {
        if (!a || doneCount >= MAX) return null;
        if (a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-no-prefetch')) return null;
        var href = a.getAttribute('href');
        if (!href || href.charAt(0) === '#' || href.indexOf('javascript') === 0) return null;
        var u;
        try { u = new URL(href, location.origin); } catch (e) { return null; }
        if (u.origin !== location.origin) return null;
        if (u.pathname === location.pathname && u.search === location.search) return null;
        if (u.searchParams.has('preview')) return null;
        for (var i = 0; i < EXCLUDE.length; i++) {
            if (u.pathname === EXCLUDE[i] || u.pathname.indexOf(EXCLUDE[i] + '/') === 0) return null;
        }
        var key = u.pathname + u.search;
        if (done[key]) return null;
        return { url: u.href, key: key };
    }

    function prefetch(t) {
        if (done[t.key]) return;
        done[t.key] = true;
        doneCount++;
        var link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = t.url;
        document.head.appendChild(link);
    }

    document.addEventListener('pointerover', function (e) {
        var a = e.target && e.target.closest && e.target.closest('a[href]');
        if (!a || a === pendingA) return;
        var t = eligible(a);
        if (!t) return;
        clearTimeout(timer);
        pendingA = a;
        timer = setTimeout(function () { pendingA = null; prefetch(t); }, 65);
    }, true);

    // Cancel the dwell only when the pointer truly leaves the anchor (moving
    // across the anchor's own children must not reset the 65ms timer).
    document.addEventListener('pointerout', function (e) {
        if (!pendingA) return;
        var to = e.relatedTarget;
        if (!to || !pendingA.contains(to)) {
            clearTimeout(timer);
            pendingA = null;
        }
    }, true);

    // Touch devices have no hover — prefetch at first touch (~100ms before
    // the click event completes).
    document.addEventListener('touchstart', function (e) {
        var a = e.target && e.target.closest && e.target.closest('a[href]');
        var t = eligible(a);
        if (t) prefetch(t);
    }, { capture: true, passive: true });
})();
